import { render } from "./reviewDealerForm.vue?vue&type=template&id=099597c2&scoped=true"
import script from "./reviewDealerForm.vue?vue&type=script&lang=js"
export * from "./reviewDealerForm.vue?vue&type=script&lang=js"

import "./reviewDealerForm.vue?vue&type=style&index=0&id=099597c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099597c2"]])

export default __exports__